import 'src/polyfills/array-prototype-at'

import mountReactApp from 'src/utils/mountReactApp'
import App from 'src/peer-fundraiser/App'

mountReactApp(App)
